export enum ChartColors {
  blue = '#7DA8FF',
  green = '#219653',
  yellow = '#F2C94C',
  purple = '#BD69FF',
}
